import React, { FC } from "react"
import { connect } from "react-redux"
import MultiCard from "../cards/MultiCard"
import { RootState } from "../../store/reducers"
import { Playlist } from "../../models/playlist"

const Playlists: FC<{
  playlists: Playlist[]
  tags?: string[]
}> = ({ playlists, tags }) => {
  document.getElementsByTagName("title")[0].innerHTML = "playlists"

  return (
    <div className="app-view">
      <div className="app-view-body" id="playlist" uk-filter="target: .uk-card">
        {/* <div>
        <h4>Filter</h4>
        <div className=" uk-text-center genres">
          {tags &&
            tags.map((tag, i) => (
              <div key={i} className="genre">
                <div
                  style={{
                    background: `linear-gradient(${Math.random() *
                      360}deg, ${randomColor()}, ${randomColor()})`
                  }}
                  className="uk-card g-card uk-padding-small uk-border-rounded"
                  uk-filter-control={`filter: .${tag}`}
                >
                  {tag}
                </div>
              </div>
            ))}
        </div>
      </div> */}
        <h4 className="app-text">My playlists</h4>
        {/* <div className="list"></div> */}
        <div id="playlist-render">
          {playlists.length ? (
            playlists &&
            playlists.map((playlist, i) => {
              return <MultiCard key={i} playlist={playlist} />
            })
          ) : (
            <div>
              <h4>
                <small>You have no current playlists</small>
              </h4>
              <button
                className="uk-button"
                uk-toggle="target: #playlists-modal"
              >
                Create playlist
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="app-view-extra ls">
        <div className="extras-body">
          <div>
            <div className="artist">
              <div
                className="artist-name"
                style={{ fontSize: "24px", marginBottom: "8px" }}
              >
                Featured
              </div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {playlists &&
                playlists.map((a, i) => <MultiCard playlist={a} key={i} />)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  // playlists: state.playlist.playlists,
  playlists: state.data.playlists,
  tags: state.songs.tags,
})

export default connect(mapStateToProps)(Playlists)
